/* ================================================== */
/* ACCESSIBILITY
/* ================================================== */

function resetSelectpicker() {
	sessionStorage.setItem('whatInput', 'keyboard');

	$('.selectpicker').each(function(index, element){
		$(element).selectpicker('destroy');
	});
}

$(document).ready(function(){
	// Convert selectpicker to native select if keyboard mode saved
	if (sessionStorage.getItem('whatInput') && sessionStorage.getItem('whatInput') === 'keyboard' && $('.selectpicker').length > 0) {
		resetSelectpicker();
	}
});